import { Stack, Typography, Button, Skeleton } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import ClienteService from "services/cliente";
import CondominioService from "services/condominio";
import ApiContext from "api";
import CardServiceNew from "components/DataDisplay/CardServiceNew/CardServiceNew";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { IconWtts } from "components/Icons/IconWtts";
import { IconLetter } from "components/Icons/IconLetter";
import { IconHeadseat } from "components/Icons/IconHeadseat";

export default function ChooseInstallation({ onChangePage }) {
    const { ConsigazApi } = useContext(ApiContext);
    const [services, setServices] = useState([]);
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [loading, setLoading] = useState(false);

    async function fetchServices() {
        setLoading(true);
        try {
            let localEntrega =
                CondominioService.selected?.["local-entrega"] ||
                ClienteService.localEntrega?.ClienteEntrRetorno?.[0]?.[
                    "cod-entrega"
                ];
            const segmento = ClienteService.localEntrega?.segmento;

            const newClientData = ClienteService.newClienteData;
            const clienteLocal = ClienteService.localEntrega;
            const cpfcnpj = newClientData?.cpfcnpj || clienteLocal?.CPFCNPJ;

            const result = await ConsigazApi.consultaServicos(
                cpfcnpj,
                localEntrega,
                segmento
            );
            setServices(result.ServicoRetorno || []);
        } catch (err) {
            console.error("Erro ao consultar serviços:", err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchServices();
    }, [ConsigazApi]);

    const installationServices = services.filter(
        (s) =>
            s.descricao === "INSTALACAO DE MEDIDOR" ||
            s.descricao === "INST COMPLETA: FOGAO,MEDIDOR E REGULADOR" ||
            "INSTALACAO DE FOGAO"
    );

    return (
        <>
            <Stack p={" 0px 32px 32px 32px"}>
                {!loading ? (
                    <>
                        <Typography
                            fontSize={"25px"}
                            fontWeight={700}
                            fontStyle={"italic"}
                            mb={"18px"}
                        >
                            {installationServices.length > 0
                                ? "Escolher instalação"
                                : "Endereço sem nova instalação disponível"}
                        </Typography>

                        <Typography
                            fontSize={"14px"}
                            fontWeight={500}
                            color="#636363"
                            align="justify"
                            lineHeight={"100%"}
                        >
                            {installationServices.length > 0
                                ? "Verificamos que o endereço informado ainda não conta com a instalação de medidor de gás. Para continuar com o religue, será necessário, antes realizar a instalação do medidor. Por favor, escolha abaixo o tipo de instalação que deseja agendar."
                                : "Não encontramos acordos comerciais para instalar um novo medidor neste endereço. Isso pode acontecer quando o local já possui um medidor instalado ou o endereço não possui opções para novas instalações. Você pode verificar se já existe um medidor no local e tentar novamente ou entrar em contato com nosso time de atendimento, em um de nossos canais abaixo, para seguir com o religue."}
                        </Typography>
                        {installationServices.length > 0 ? (
                            <Stack sx={{ height: "500px" }}>
                                <Swiper
                                    modules={[Pagination]}
                                    slidesPerView={1.5}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                    centeredSlides={true}
                                    pagination={{ clickable: true }}
                                    spaceBetween={80}
                                >
                                    {installationServices.map((service) => {
                                        const serviceId = service["descricao"];
                                        const isSelected =
                                            selectedServiceId === serviceId;

                                        return (
                                            <SwiperSlide
                                                key={serviceId}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <CardServiceNew
                                                    id={serviceId}
                                                    title={service.descricao}
                                                    description={
                                                        service.detalhes
                                                    }
                                                    value={
                                                        service["vl-servico"]
                                                    }
                                                    serviceDeadline={
                                                        service[
                                                            "prazo-inicio-servico"
                                                        ]
                                                    }
                                                    paymentDeadline={
                                                        service["cod-cond-pag"]
                                                    }
                                                    isSelected={isSelected}
                                                    onSelect={
                                                        setSelectedServiceId
                                                    }
                                                />
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                            </Stack>
                        ) : (
                            <Stack
                                alignItems={"center"}
                                mt={10}
                                mb={10}
                                direction={"row"}
                                justifyContent={"space-between"}
                            >
                                <Stack
                                    p={"16px"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    sx={{ cursor: "pointer" }}
                                    bgcolor={"#053462"}
                                    borderRadius={"8px"}
                                    width={"13%"}
                                    height={"80px"}
                                    onClick={() =>
                                        window.open(
                                            `https://api.whatsapp.com/send?phone=5511997770000`,
                                            "_blank"
                                        )
                                    }
                                >
                                    <IconWtts />
                                    <Typography
                                        fontWeight={600}
                                        fontSize={"12px"}
                                        color="#FFFFFF"
                                    >
                                        WhatsApp
                                    </Typography>
                                </Stack>
                                <Stack
                                    p={"16px"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    sx={{ cursor: "pointer" }}
                                    bgcolor={"#053462"}
                                    borderRadius={"8px"}
                                    width={"13%"}
                                    height={"80px"}
                                    onClick={() =>
                                        window.open(
                                            "mailto:cac@consigaz.com.br",
                                            "_blank"
                                        )
                                    }
                                >
                                    <IconLetter />
                                    <Typography
                                        fontWeight={600}
                                        fontSize={"12px"}
                                        color="#FFFFFF"
                                    >
                                        Email
                                    </Typography>
                                </Stack>
                                <Stack
                                    p={"16px"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    borderRadius={"8px"}
                                    width={"13%"}
                                    height={"80px"}
                                    border={"2px solid #053462"}
                                >
                                    <IconHeadseat />
                                    <Typography
                                        fontWeight={600}
                                        fontSize={"10px"}
                                        color="#053462"
                                    >
                                        0800 940 0244
                                    </Typography>
                                </Stack>
                                <Stack
                                    p={"16px"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    borderRadius={"8px"}
                                    width={"13%"}
                                    height={"80px"}
                                    border={"2px solid #053462"}
                                >
                                    <IconHeadseat />
                                    <Typography
                                        fontWeight={600}
                                        fontSize={"10px"}
                                        color="#053462"
                                    >
                                        (11) 4766-9400
                                    </Typography>
                                </Stack>
                            </Stack>
                        )}
                    </>
                ) : (
                    <>
                        <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                        <Stack
                            justifyContent={"center"}
                            alignItems={"center"}
                            height={"500px"}
                        >
                            <Skeleton
                                variant="rectangular"
                                width={350}
                                height={300}
                            />
                        </Stack>
                    </>
                )}
            </Stack>
            <Stack height={"135px"} bgcolor={"#053462"}>
                <Stack alignItems={"center"}>
                    <Stack
                        alignSelf={"flex-start"}
                        mt={"25px"}
                        ml={"31px"}
                        mb={"28px"}
                    >
                        <button
                            className="inline-link"
                            onClick={() =>
                                window.open("/warranty-terms", "_blank")
                            }
                        >
                            Termos de garantia
                        </button>
                    </Stack>
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                            color: "#fff",
                            height: "45px",
                            width: "358px",
                            borderRadius: "36px",
                        }}
                        disabled={!selectedServiceId}
                        onClick={() => {
                            if (selectedServiceId) {
                                const service = services.find(
                                    (s) => s.descricao === selectedServiceId
                                );

                                if (
                                    service.descricao ===
                                        "INSTALACAO DE FOGAO" ||
                                    service.descricao ===
                                        "INST COMPLETA: FOGAO,MEDIDOR E REGULADOR"
                                ) {
                                    return onChangePage(
                                        "confirmServiceStove",
                                        service
                                    );
                                }

                                onChangePage("confirmService", service);
                            }
                        }}
                    >
                        SELECIONAR
                    </Button>
                </Stack>
            </Stack>
        </>
    );
}
